<script setup>
import { onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import SelectService from '@/components/vehicle/select_service.vue'
import { useRequestAQuoteStore } from '@/stores/request_a_quote.js'
import { indexCategories } from '@/lib/api/categories.js'

const props = defineProps({})

// I18n
const { t } = useI18n()

// Stores
const requestAQuoteStore = useRequestAQuoteStore()

// Variables
const isCategoriesLoading = ref(true)
const categories = ref([])

// Event Handlers
onMounted(async () => {
  await getCategories()
})

watch(() => null, () => {
})

// Functions
async function getCategories() {
  await indexCategories()
    .then((response) => {
      categories.value = response
      isCategoriesLoading.value = false
    })
}

</script>

<template>
  <div>
    <SelectService v-for="(service, index) in requestAQuoteStore.selectedServices" :key="index" :service="service"
                   :index="index + 1" :is-categories-loading="isCategoriesLoading" :categories="categories" />
    <div class="my-8 border-t"></div>
  </div>
</template>

<style lang="scss" scoped>
</style>
